import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import ConfigurationFieldsTranslations
    from '@/modules/configurationModule/shared/components/configuration-fields-translations/configuration-fields-translations.vue'
import { ConfigurationPossibleAssayResultResponse } from '@/modules/configurationModule/detail/local-assays/results/services/configuration-possible-assay-result/configuration-possible-assay-result.dto'
import { Validator } from 'vee-validate'

@Component({
    components: {
        ConfigurationFieldsTranslations
    }
})
export default class ConfigurationLocalAssaysResultsModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly possibleAssayResult!: Partial<ConfigurationPossibleAssayResultResponse>

    @Inject() externalValidator!: Validator

    get updateMode(): boolean {
        return !!this.possibleAssayResult?.id
    }

    constructor() {
        super()

        this.$validator = this.externalValidator
    }
}
